function CombineTechStackComponentMobile({
  logo1,
  name1,
  name2,
  name3,
  name4,
  name5,
}: any) {
  return (
    <div className="bg-gray-3 py-4 flex flex-col w-[300px] items-center justify-around rounded">
      <div className=" rounded-md flex flex-col items-center justify-center mb-2">
        <div className="w-[35px] overflow-hidden rounded mb-3">
          <img
            src={logo1}
            alt="thumbnail"
            className="object-cover w-full h-full"
          />
        </div>
        <p className="font-medium text-[11px]">{name1}</p>
      </div>

      <div className="flex flex-row justify-evenly items-center w-full">
        <div className="flex flex-col font-medium text-[12px]">
          <p className="mb-2">- {name4}</p>
          <p className="">- {name3}</p>
        </div>

        <div className="flex flex-col font-medium text-[12px]">
          <p className=" mb-2">- {name2}</p>
          <p className="">- {name5}</p>
        </div>
      </div>
    </div>
  );
}

export default CombineTechStackComponentMobile;
